



























































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyList from "@/mixins/list";
import moment from "moment";
import AreaPicker from "@/components/areapicker.vue";
import SelectCustomer from "@/components/selectcustomer.vue";

import { isAI, isCooperate, isTelBooking } from "@/libs/utils";
import Audit from "@/views/enterapply/audit.vue";
import SyslogManage from "@/views/syslog/manage.vue";
import SyslogEnterapply from "@/views/syslog/action.vue";
import Fans from "@/views/oplatform/fans/index.vue";
import TaisamAccount from "@/views/taisam-account/index.vue";
import Price from "./price.vue";
import EquipmentControl from "./equipment_control.vue";
import Equipment from "./equipment.vue";
import Add from "./add.vue";
import Modal from "./modal.vue";
import Settlement from "./settlement.vue";
import Ground from "./ground.vue";
import Product from "./product.vue";
import Online from "./online.vue";
import ManageRecord from "./manage_record.vue";
import Member from "./member.vue";
import User from "./user.vue";
import Account from "./account.vue";
import Role from "./role.vue";
import InviteLog from "../invitecode/logs.vue";
import Similar from "./similar.vue";
import Edit from "./edit.vue";

import GroundCalendar from "./ground_calendar.vue";

import ParamsSetting from "./params-setting/params-setting.vue";
import SpecialOperation from "./special-operation/index.vue";

import ResearchReport from "../enterapply/research_report.vue";

@Component({
  components: {
    ResearchReport,
    AreaPicker,
    Add,
    Modal,
    Price,
    EquipmentControl,
    Equipment,
    Settlement,
    Ground,
    Product,
    Online,
    ManageRecord,
    Member,
    User,
    Account,
    Role,
    InviteLog,
    Similar,
    SelectCustomer,
    Edit,
    Audit,
    GroundCalendar,
    SyslogManage,
    SyslogEnterapply,
    Fans,
    TaisamAccount,
    ParamsSetting,
    SpecialOperation
  }
})
export default class extends Mixins(MyList) {
  @Prop() stype!: any;

  reportModalVisible = false;

  dispatchType = "stadium/getStadiums";

  priceModalVisible = false;

  controlModalVisible = false;

  equipModalVisible = false;

  settlementModalVisible = false;

  fansModalVisible = false;

  groundModalVisible = false;

  productModalVisible = false;

  onlineModalVisible = false;

  managerecordModalVisible = false;

  memberModalVisible = false;

  userModalVisible = false;

  accountModalVisible = false;

  bookingblockModalVisible = false;

  roleModalVisible = false;

  invitelogModalVisible = false;

  similarModalVisible = false;

  newEditModalVisible = false;

  auditModalVisible = false;

  syslogManageModalVisible = false;

  syslogEnterapplyModalVisible = false;

  calendarModalVisible = false;

  taisamAccountModalVisible = false;

  stadiumId!: number;

  fromStadiumId = 0;

  customerId = 0;

  applyId = 0;

  limit =0;

  stadium: any = {};

  auth_user_id = 0;

  isAI: (...args: any[]) => any = isAI;

  isCooperate: (...args: any[]) => any = isCooperate;

  isTelBooking: (...args: any[]) => any = isTelBooking;

  // sType = "";
  columns: any[] = [];

  columns1: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "城市", dataIndex: "city_name" },
    { title: "场馆名称", scopedSlots: { customRender: "name" } },
    { title: "场馆注册时间", dataIndex: "created_time" },
    { title: "标识", scopedSlots: { customRender: "stype" } },
    { title: "馆长", scopedSlots: { customRender: "manager_name" } },
    { title: "订场电话", dataIndex: "phone" },
    { title: "场地片数", dataIndex: "ground_count" }
  ];

  columnsForParamSetting: any[] = [
    { title: "编号", dataIndex: "id", fixed: "left" },
    { title: "城市", dataIndex: "city_name", fixed: "left" },
    { title: "场馆名称", scopedSlots: { customRender: "name" }, fixed: "left" }
  ];

  columns2: any[] = [{ title: "场馆主体", dataIndex: "business_units" }];

  columns3: any[] = [
    { title: "上线状态", scopedSlots: { customRender: "online_status" } },
    {
      title: "场馆状态",
      width: 100,
      scopedSlots: { customRender: "stadium_status" }
    }
  ];

  columns4: any[] = [{ title: "操作", width: 200, scopedSlots: { customRender: "action" } }];

  columns4ForParamSetting: any[] = [
    {
      title: "操作",
      width: 200,
      scopedSlots: { customRender: "action" },
      fixed: "right"
    }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  @Watch("loading")
  watchLoading(to: any, from: any) {
    if (to != from) {
      this.selectedRowKeys = [];
    }
  }

  @Watch("$route")
  watchRoute(to: any, from: any) {
    this.limit=this.stype=="limitai"?1:0;
    if(this.stype=="limitai"){
      this.stype="ai";
    }
    if (!_.isEqual(from, to)) {
      if (to.path !== from.path) {
        this.searchData = {};
      }
      switch (this.stype) {
        case "manager":
        case "newly":
        case "new":
          this.columns = _.concat(this.columns1, this.columns4);
          break;
        case "pending":
          this.columns = _.concat(this.columns1, this.columns2, this.columns4);
          break;
        case "active":
        case "internal":
        case "database":
        case "all":
        case "wechat":
        case "tel":
        case "ai":
        case "24ai":
        case "params-setting":
          if (this.stype !== "params-setting") {
            this.columns = _.concat(this.columns1, this.columns2, this.columns3, this.columns4);
          } else {
            this.getParamsSetting();
            // this.columns = _.concat(
            //   this.columnsForParamSetting,
            //   this.columns4
            // );
          }
          break;
        default:
          break;
      }
    }
    // this.stype = to.params.key;
    // this.searchData = {};

    this.doLoadData();
  }

  doLoadData(){
    if(this.stype=="ai"){
      this.loadData({
        stype: this.stype,
        has_stadium_info: "1",
        limit:this.limit,
      });
    } else {
      this.loadData({
        stype: this.stype,
        has_stadium_info: "1"
      });
    }
  }

  showReportModal() {
    this.reportModalVisible = true;
  }

  hideReportModal() {
    this.reportModalVisible = false;
    this.loadData();
  }

  showFansModal(id: number, auth_user_id: number, stadiumId: number) {
    this.editId = id;
    this.auth_user_id = auth_user_id;
    this.fansModalVisible = true;
  }

  hideFansModal() {
    this.fansModalVisible = false;
    this.loadData({
      stype: this.stype
    });
  }

  async selectFans(obj: any) {
    // console.log(obj);
    if (obj) {
      const res = await this.$store.dispatch("stadium/bindAuthUser", {
        stadium_id: this.editId,
        auth_user_id: obj.id
      });
      if (res && res.Message && res.Message === "success") {
        this.$message.success("操作成功");
        this.hideFansModal();
      } else {
        this.$message.error(res.Message);
      }
    }
  }

  unbindAuthUser(id: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "确定要解绑微信吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/unbindAuthUser", {
          stadium_id: id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData({
            stype: this.stype
          });
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  showIsInternalSwitch(record: any) {
    this.$confirm({
      title: "内部馆标识开关",
      content: (h: any) => `当前状态：${record.is_internal == 1 ? "开" : "关"}`,
      okText: "开",
      cancelText: "关",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/setIsInternal", {
          stadium_id: record.id,
          status: 1
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData({
            stype: this.stype
          });
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel: async () => {
        const res = await this.$store.dispatch("stadium/setIsInternal", {
          stadium_id: record.id,
          status: 0
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData({
            stype: this.stype
          });
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  showAddStadiumModal(id: number, stadiumId: number) {
    this.customerId = id;
    this.fromStadiumId = stadiumId;
    this.addModalVisible = true;
  }

  hideAddStadiumModal() {
    this.addModalVisible = false;
    this.customerId = 0;
    this.fromStadiumId = 0;
    this.loadData({
      stype: this.stype
    });
  }

  showAuditModal(id: number) {
    this.stadiumId = id;
    this.auditModalVisible = true;
  }

  hideAuditModal() {
    this.auditModalVisible = false;
  }

  showCalendarModal(id: number) {
    this.stadiumId = id;
    this.calendarModalVisible = true;
  }

  hideCalendarModal() {
    this.calendarModalVisible = false;
  }

  showSyslogManageModal(id: number) {
    // console.log(id);
    this.stadiumId = id;
    this.syslogManageModalVisible = true;
  }

  hideSyslogManageModal() {
    this.syslogManageModalVisible = false;
  }

  showSyslogEnterapplyModal(id: number) {
    this.stadiumId = id;
    this.syslogEnterapplyModalVisible = true;
  }

  hideSyslogEnterapplyModal() {
    this.syslogEnterapplyModalVisible = false;
  }

  showTaisamAccountModal(id: number, customerId: number) {
    this.stadiumId = id;
    this.customerId = customerId;
    this.taisamAccountModalVisible = true;
  }

  hideTaisamAccountModal() {
    this.taisamAccountModalVisible = false;
  }

  changeArea(val: any, selectedOptions: any) {
    if (val.length > 1) {
      this.searchData.province_id = val[0] as number;
      this.searchData.city_id     = val[1] as number;
    } else if (val.length > 0) {
      this.searchData.province_id = val[0] as number;
    }
  }

  // 选择
  get rowSelection() {
    switch (this.stype) {
      case "wechat":
      case "params-setting":
        return {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        };
      default:
    }

    return null;
  }

  resignApplyAgreement(stadiumId: number, name: string) {
    this.$confirm({
      title: "确认信息",
      content: `确认要向场馆”${name}“重新签约入驻协议吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/resignApplyAgreement", {
          stadium_id: stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("激活成功");
        } else {
          this.$message.error("激活失败");
        }
      }
    });
  }

  createTaisamStadium(data: any) {
    this.$confirm({
      title: "确认信息",
      content: `确认根据场馆”${data.name}“创建新场馆吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/cloneStadium", {
          id: data.id,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("创建成功");
        } else {
          this.$message.error("创建失败");
        }
      }
    });
  }

  resignAIAgreement(stadiumId: number, name: string) {
    this.$confirm({
      title: "确认信息",
      content: `确认要向场馆”${name}“重新签约智能硬件投放协议吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/resignAIAgreement", {
          stadium_id: stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("跳过成功");
        } else {
          this.$message.error("跳过失败");
        }
      }
    });
  }

  /// 专项运营 start =================================================================
  specialOperationModalVisible = false;

  showSpecialOperationModal() {
    this.specialOperationModalVisible = true;
  }

  hideSpecialOperationModal() {
    console.log("modal close", this.showSpecialOperationModal);
    this.specialOperationModalVisible = false;
  }

  async openSpecialOperation(stadiumId: number, name: string) {
    this.$confirm({
      title: "确认信息",
      content: `确认要向场馆”${name}“推送专项运营吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch("specialOperation/open", {
          stadium_id: stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("发起成功");
        } else {
          this.$message.error("发起失败");
        }
      }
    });
  }

  /// 专项运营 end =================================================================

  /// 批量设置场馆参数start =================================================================

  // 操作符下拉
  operators: any = [
    { value: "eq", name: "等于" },
    { value: "neq", name: "不等于" },
    { value: "gt", name: "大于" },
    { value: "ge", name: "大等于" },
    { value: "lt", name: "小于" },
    { value: "le", name: "小等于" }
  ];

  paramsModalVisible = false;

  multiParamsSetting: any[] = [];

  hideParamsModal() {
    this.paramsModalVisible = false;
    this.selectedRowKeys = [];
  }

  handleMultiParamsSetting() {
    console.log("selectedRowKeys", this.selectedRowKeys);
    if (this.selectedRowKeys.length === 0) {
      this.$message.warning("请选择要设置的场馆");
      return;
    }
    this.paramsModalVisible = true;
  }

  get isMultiParamsSetting() {
    return this.stype === "params-setting";
  }

  // 修改规则项
  changeSettingName(idx: number, val: any) {
    this.searchData.setting_name = val;
    let value = "";
    if (this.isDict(val)) {
      const dict = this.getDict(val);
      if (dict && dict[0]) {
        value = dict[0] as string
      }
    }
    this.searchData.setting_value = value;
    this.form.setFieldsValue({
      setting_value: value
    });
    console.log("changeSettingName", { val, value });
  }

  changeSettingValue(idx: number, val: any) {
    this.searchData.setting_value = val;
  }

  changeSettingOperation(idx: number, val: any) {
    this.searchData.setting_operation = val;
  }

  isDict(col: string) {
    const found = this.multiParamsSetting.find(el => el.col === col);
    if (found) {
      return Array.isArray(found.dict) && found.dict.length > 0;
    }

    return false;
  }

  getDict(col: string) {
    const found = this.multiParamsSetting.find(el => el.col === col);
    if (found && found.dict && found.dict.length > 0) {
      return found.dict;
    }

    return [];
  }

  async getParamsSetting() {
    const res = await this.$store.dispatch("stadium/getParamsSetting", {});
    if (res && res.Message && res.Message === "success") {
      this.multiParamsSetting = res.Data;
      const paramSettingColumns = _.concat(
        this.columns,
        res.Data.map((el: any, i: number) => {
          const _isDict = this.isDict(el.col);
          return {
            title: el.desc,
            customRender: (text: any, record: any, index: any) => {
              // console.log("customRender", text, el, record, index, index);
              if (_isDict) {
                const dict = this.getDict(el.col);
                return this.$createElement("div", {}, [
                  this.$createElement(
                    "a-tag",
                    {
                      props: {
                        color: record[el.col] == 1 ? "#108ee9" : ""
                      }
                    },
                    dict[record[el.col] || 0]
                  )
                ]);
              }
              return this.$createElement("div", {}, [
                this.$createElement("span", {}, record[el.col])
              ]);
            }
          };
        })
      );

      this.columns = _.concat(
        this.columnsForParamSetting,
        paramSettingColumns,
        this.columns4ForParamSetting
      );

      console.log("this.columns", this.columns);
    } else {
      this.$message.error(res.Message);
    }
  }

  /// 批量选择微信接单馆end =================================================================

  /// 批量选择微信接单馆start =================================================================

  changeWechatStadiumOr(stadiumId: number, stadiumName: string) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要将${stadiumName}场馆强制转为智能场馆?`,
      onOk: () => {
        this.$store.dispatch("stadium/wechatStadiumSetting", {
          stadium_id: stadiumId,
          status: 0
        });
        this.$message.success("操作成功");
        this.hideFansModal();
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      }
    });
  }

  get isWechatBill() {
    return this.stype === "wechat";
  }

  selectedRowKeys: any[] = [];

  // 下单框
  formForBill!: any;

  billData = {
    start_date: "",
    start_time: "",
    end_time: ""
  };

  disabledDate(current: any) {
    if (!current) {
      return false;
    }

    if (current < moment().add(-1, "day")) {
      return true;
    }

    if (current >= moment().add("8", "day")) {
      return true;
    }

    return false;
  }

  disabledRangeTime(_: any, _type: string) {
    return {};
  }

  checkMultiWechatBillHasBind(): boolean {
    const messages: string[] = [];
    this.data.forEach(el => {
      if (this.selectedRowKeys.indexOf(el.id) >= 0) {
        if (el.auth_user_id > 0) {
          messages.push(`"${el.name}"场馆已绑定`);
          return true;
        }

        if (el.stadium_status == 0) {
          messages.push(`"${el.name}"场馆已下线`);
          return true;
        }

        if (el.ground_count == 0) {
          messages.push(`"${el.name}"场馆无片场`);
          return true;
        }
      }
    });

    if (messages.length > 0) {
      const h = this.$createElement;
      this.$warning({
        title: "提示",
        content: h("div", {}, messages.map(el => h("p", String(el))))
      });
      return true;
    }

    return false;
  }

  handleMultiWechatBill(e: any) {
    e.preventDefault();
    this.formForBill.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        // console.log(fieldsValue)
        const values: any = {};
        for (const key in fieldsValue) {
          if (_.get(fieldsValue, [key])) {
            const fieldValue = _.get(fieldsValue, [key]);
            if (moment.isMoment(fieldValue)) {
              console.log("fieldValue", key, { key, fieldValue });
              switch (key) {
                case "start_date":
                  _.set(values, [key], moment(fieldValue).format("YYYY-MM-DD"));
                  break;
                case "start_time":
                  _.set(values, [key], moment(fieldValue).format("HH:00:00"));
                  break;
                case "end_time":
                  _.set(values, [key], moment(fieldValue).format("HH:00:00"));
                  break;
              }
            } else if (key === "area") {
              _.set(values, ["province_id"], _.get(fieldValue, [0], ""));
              _.set(values, ["city_id"], _.get(fieldValue, [1], ""));
              _.set(values, ["county_id"], _.get(fieldValue, [2], ""));
            } else {
              _.set(values, [key], fieldValue);
            }
          } else {
            _.unset(this.reloadQueryData, [key]);
          }
        }
        this.billData = {
          ...values
        };
        this.onMultiWechatBill();
      }
    });
  }

  // 批量下单
  async onMultiWechatBill() {
    console.log("billData", this.billData);
    if (!this.selectedRowKeys.length) {
      this.$warning({
        title: "提示",
        content: "请选择场馆"
      });
      return;
    }

    if (this.checkMultiWechatBillHasBind()) {
      return;
    }

    if (!this.billData.start_date) {
      this.$warning({
        title: "提示",
        content: "请选择日期"
      });
      return;
    }

    if (!this.billData.start_time) {
      this.$warning({
        title: "提示",
        content: "请选择开始时间"
      });
      return;
    }

    if (!this.billData.end_time) {
      this.$warning({
        title: "提示",
        content: "请选择结束时间"
      });
      return;
    }

    if (this.billData.start_time >= this.billData.end_time) {
      this.$warning({
        title: "提示",
        content: "开始时间不能大于结束时间"
      });
      return;
    }

    const now = moment();
    const now_hour = moment([now.year(), now.month(), now.date(), now.hour(), 0, 0]);
    const next_hour = moment([now.year(), now.month(), now.date(), 1 + now.hour(), 0, 0]);
    const start = moment(`${this.billData.start_date} ${this.billData.start_time}`);
    const end = moment(`${this.billData.start_date} ${this.billData.end_time}`);
    const diff = now.diff(start, "second");

    if (now.diff(start, "minute") > 0) {
      this.$warning({
        title: "提示",
        content: "请选择正确的开始时间"
      });
      return;
    }

    if (start.diff(now, "minute") <= 5) {
      this.$warning({
        title: "提示",
        content: "下单时间离开场时间不能小于5分钟"
      });
      return;
    }

    if (end.diff(start, "hour") > 4) {
      this.$warning({
        title: "提示",
        content: "打球时间不能大于4小时"
      });
      return;
    }

    const start_time = start.format("YYYY-MM-DD HH:mm:ss");
    const end_time = end.format("YYYY-MM-DD HH:mm:ss");

    console.log("onMultiWechatBill", {
      now,
      now_hour,
      next_hour,
      start,
      end,
      diff,
      start_date: this.billData.start_date,
      src_start_time: this.billData.start_time,
      src_end_time: this.billData.end_time,
      start_time,
      end_time
    });

    // return

    this.$confirm({
      title: "微信批量下单",
      content: "确定要下单吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("bill/multiWechatBill", {
          stadium_ids: this.selectedRowKeys,
          start_time,
          end_time
        });
        // 清空
        this.selectedRowKeys = [];
        if (res && res.Message && res.Message === "success") {
          this.$success({
            title: "提示",
            content: "操作成功, 结果请以微信推送为准"
          });
          this.hideFansModal();
        } else {
          this.$error({
            title: "提示",
            content: res.Message
          });
        }
      }
    });
  }

  // 场馆ID
  onSelectChange(selectedRowKeys: any, selectedRows: any) {
    this.selectedRowKeys = selectedRowKeys;
  }

  // 下单
  handleMultiBill() { }

  beforeCreate() {
    this.formForBill = this.$form.createForm(this, {
      // onValuesChange: (props, values) => {
      //     console.log(props)
      //     console.log(values)
      // }
    });
  }

  /**
   * 输出时间
   * @param time 时间
   */
  renderTime(time: any) {
    if (!_.isEmpty(time)) {
      if (moment.isMoment(time)) {
        return time;
      }
      return moment(moment().format("YYYY-MM-DD ") + time);
    }
    return null;
  }

  /// 批量选择微信接单馆end =================================================================

  mounted() {
    this.limit=this.stype=="limitai"?1:0;
    if(this.stype=="limitai"){
      this.stype="ai";
    }
    switch (this.stype) {
      case "manager":
      case "newly":
        this.columns = _.concat(this.columns1, this.columns4);
        break;
      case "pending":
        this.columns = _.concat(this.columns1, this.columns2, this.columns4);
        break;
      case "active":
      case "internal":
      case "database":
      case "all":
      case "wechat":
      case "tel":
      case "ai":
      case "24ai":
      case "params-setting":
        if (this.stype !== "params-setting") {
          this.columns = _.concat(this.columns1, this.columns2, this.columns3, this.columns4);
        } else {
          // this.columns = _.concat(
          //   this.columnsForParamSetting,
          //   this.columns4
          // );
        }

        if (this.stype === "wechat") {
          this.billData.start_date = moment().format("YYYY-MM-DD");
          this.billData.start_time = moment()
            .add(1, "hour")
            .format("HH:00:00");
          this.billData.end_time = moment()
            .add(2, "hour")
            .format("HH:00:00");
        }

        if (this.stype === "params-setting") {
          this.getParamsSetting();
        }

        break;
      default:
        break;
    }
    this.doLoadData();
  }

  showEquipModal(id: number) {
    this.stadiumId = Number(id);
    this.equipModalVisible = true;
  }

  hideEquipModal() {
    this.equipModalVisible = false;
  }

  showPriceModal(id: number) {
    this.stadiumId = id;
    this.priceModalVisible = true;
  }

  hidePriceModal() {
    this.priceModalVisible = false;
  }

  showControlModal(id: number) {
    this.stadiumId = id;
    this.controlModalVisible = true;
  }

  hideControlModal() {
    this.controlModalVisible = false;
  }

  showSettlementModal(id: number) {
    this.stadiumId = id;
    this.settlementModalVisible = true;
  }

  hideSettlementModal() {
    this.settlementModalVisible = false;
  }

  showGroundModal(id: number) {
    this.stadiumId = id;
    this.groundModalVisible = true;
  }

  hideGroundModal() {
    this.groundModalVisible = false;
  }

  showProductModal(id: number) {
    this.stadiumId = id;
    this.productModalVisible = true;
  }

  hideProductModal() {
    this.productModalVisible = false;
  }

  showOnlineModal(id: number) {
    this.applyId = id;
    this.onlineModalVisible = true;
  }

  hideOnlineModal() {
    this.onlineModalVisible = false;
  }

  showManageRecordModal(id: number) {
    this.stadiumId = id;
    this.managerecordModalVisible = true;
  }

  hideManageRecordModal() {
    this.managerecordModalVisible = false;
  }

  showBookingBlockModal(id: number) {
    this.stadiumId = id;
    this.bookingblockModalVisible = true;
  }

  hideBookingBlockModal() {
    this.bookingblockModalVisible = false;
  }

  showMemberModal(id: number) {
    this.stadiumId = id;
    this.memberModalVisible = true;
  }

  hideMemberModal() {
    this.memberModalVisible = false;
  }

  showUserModal(id: number) {
    this.stadiumId = id;
    this.userModalVisible = true;
  }

  hideUserModal() {
    this.userModalVisible = false;
  }

  showAccountModal(id: number) {
    this.stadiumId = id;
    this.accountModalVisible = true;
  }

  hideAccountModal() {
    this.accountModalVisible = false;
  }

  showRoleModal(id: number) {
    this.stadiumId = id;
    this.roleModalVisible = true;
  }

  hideRoleModal() {
    this.roleModalVisible = false;
  }

  showInvitelogModal(id: number, applyId: number) {
    this.stadiumId = id;
    this.applyId = applyId;
    this.invitelogModalVisible = true;
  }

  hideInvitelogModal() {
    this.invitelogModalVisible = false;
  }

  showSimilarModal(stadium: any) {
    // console.log(stadium)
    this.stadium = stadium;
    this.similarModalVisible = true;
  }

  hideSimilarModal() {
    this.similarModalVisible = false;
  }

  showNewEditModal(stadiumId: number) {
    this.editId = stadiumId;
    this.newEditModalVisible = true;
  }

  hideNewEditModal() {
    this.newEditModalVisible = false;
    this.loadData({ stype: this.stype });
  }

  async setStadiumStatus(val: any, id: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: `您确定要${val === false ? "下线" : "上线"}该场馆吗？`,
      onOk: async () => {
        if (!this.checkPermission("admin-stadium-stadium-status")) {
          this.$message.warning("没有权限");
          return;
        }
        const res = await this.$store.dispatch("stadium/stadiumstatus", {
          id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData({
            stype: this.stype
          });
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }

  async sendInviteCode(stadiumId: number) {
    this.$confirm({
      title: "确认信息",
      content: "您确定要给这家场馆发送邀请码吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/sendinvitecode", {
          stadium_id: stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  copyDemoData(id: number) {
    this.$confirm({
      title: "确认消息",
      content: "你确定拷贝最近2个月演示场馆的数据到该场馆吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/copyDemoData", {
          stadium_id: id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  copyDayDemoData(id: number) {
    this.$confirm({
      title: "确认消息",
      content: "你确定拷贝当天演示场馆的数据到该场馆吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/copyDemoData", {
          stadium_id: id,
          t: "day"
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  deleteDemoData(id: number) {
    this.$confirm({
      title: "确认消息",
      content: "你确定要删除该场馆的演示数据吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/deleteDemoData", {
          stadium_id: id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
